// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileItem__container-ec7ea3 {
  display: flex;
  align-items: center;
  padding: 12px var(--padding);
}

.FileItem__info-fcfbf8 {
  margin-inline-start: 8px;
  margin-top: -4px;
  overflow: hidden;
}

.FileItem__title-f056f9 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
}

.FileItem__description-f6b1ec {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/SharedData/Files/FileItem/FileItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;AACF;;AAEA;EACE,wBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  padding: 12px var(--padding);\n}\n\n.info {\n  margin-inline-start: 8px;\n  margin-top: -4px;\n  overflow: hidden;\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n}\n\n.description {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FileItem__container-ec7ea3`,
	"info": `FileItem__info-fcfbf8`,
	"title": `FileItem__title-f056f9`,
	"description": `FileItem__description-f6b1ec`
};
module.exports = ___CSS_LOADER_EXPORT___;
